import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { BrowserStorageLocalService } from 'pf-frontend-common/src/service/browser-storage-local/service';

import { PropertyShareStoreFactory } from 'common/data/property-share/store.factory';
import { GoogleRecaptchaViewStoreFactory } from 'common/module/google/recaptcha/view-store.factory';
import { StatechartStoreFactory } from 'common/module/statechart/store.factory';

import { FormPropertyShareViewStore } from './view-store';

export function FormPropertyShareViewStoreFactory(): FormPropertyShareViewStore {
  return new FormPropertyShareViewStore(
    EventEmitterFactory(),
    PropertyShareStoreFactory(),
    GoogleRecaptchaViewStoreFactory(),
    BrowserStorageLocalService(),
    StatechartStoreFactory()
  );
}
